import React from 'react'
import './Designer2.scss';

let Designer;

export default class DeferredDesigner extends React.Component{
  state = {
    fetchingBundle: true
  }
  componentDidMount = () => {
    this.fetchDesignerBundle()
  }
  fetchDesignerBundle = () => {
    require.ensure(
  		['./Designer2'],
  		require => {
  			Designer = require('./Designer2').default
        this.setState({fetchingBundle: false})
  		},
  		'designer_dependencies'
  	)
  }
  render(){
    return(
      this.state.fetchingBundle ?
      null
      :
      <Designer {...this.props} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Designer2/DeferredDesigner.js